export default __webpack_public_path__ + "static/media/8.9813af26.jpg";